import { render, staticRenderFns } from "./MusicLibraryPage.vue?vue&type=template&id=3b75e800"
import script from "./MusicLibraryPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MusicLibraryPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports